import { resolveEventVideoSource } from "@shared/eventVideo";

export default function EventVideoPlayer({
  url,
  title,
}: {
  url: string;
  title: string;
}) {
  const source = resolveEventVideoSource(url);
  if (!source) return null;

  return (
    <div
      className="event-video-player"
      style={{
        width: "100%",
        aspectRatio: "16 / 9",
        overflow: "hidden",
        borderRadius: "1rem",
        border: "1px solid rgba(255,255,255,.14)",
        background: "#03050A",
        boxShadow: "0 18px 50px rgba(0,0,0,.32)",
      }}
    >
      {source.type === "storage" ? (
        <video
          src={source.playbackUrl}
          title={title}
          controls
          preload="metadata"
          playsInline
          style={{ display: "block", width: "100%", height: "100%", objectFit: "contain" }}
        >
          Your browser does not support this video.
        </video>
      ) : (
        <iframe
          src={source.playbackUrl}
          title={title}
          loading="lazy"
          allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
          allowFullScreen
          referrerPolicy="strict-origin-when-cross-origin"
          style={{ display: "block", width: "100%", height: "100%", border: 0 }}
        />
      )}
    </div>
  );
}